import Request from '@/utils/request'

export function apiFetchSubAgentWeekAct(params) {
  return Request({
    url: '/api/v2/app/sub/agent/week/act',
    method: 'get',
    params,
    envelope: false,
  })
}

export function apiFetchSubAgentCarousel() {
  return Request({
    url: '/api/v2/app/sub/agent/carousel',
    method: 'get',
    envelope: false,
  })
}
